import { render, staticRenderFns } from "./IDScanPDFReport.vue?vue&type=template&id=0edfbc5e"
import script from "./IDScanPDFReport.vue?vue&type=script&lang=js"
export * from "./IDScanPDFReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports